/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const CardDamaged = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M9.58426 2L11.572 4.47H11.646L12.853 5.97H12.78L14.792 8.47H14.865L15.537 9.30326L14.195 10.969H14.121L9.999 16.09V16.193L12.192 18.97H12.281L13.466 20.47H13.376L14.5887 22.0055L13.4113 22.935L11.466 20.47L1 20.4703V4.47026L9.646 4.47L8.41574 2.94051L9.58426 2ZM23 4.47026V20.4703L15.376 20.47L14.192 18.97L21.5 18.9703V10.9693L16.121 10.969L17.4628 9.30359L16.792 8.47L21.5 8.47026V5.97026L14.779 5.97L13.572 4.47L23 4.47026ZM8.17 15.97L12.195 10.969L2.5 10.9693V18.9703L10.281 18.97L9.097 17.47L4 17.4703V15.9703L8.17 15.97ZM10.854 5.97L2.5 5.97026V8.46926L12.865 8.47L10.854 5.97Z"
                        fill={color}
                    />
                </svg>
        );
    };
